import {apiVersion} from '.';

const baseURL = `${apiVersion.default}`;

export const {verifyNrbToken, submitNrbFacialVerification} = {
    verifyNrbToken: token => `${baseURL}/nrb-facial-verification/${token}`,
    submitNrbFacialVerification: `${baseURL}/nrb-facial-verification`,
};
